module.exports = __webpack_public_path__ + "img/icon5.8f082ef0.svg";